<template>
<div>
    <span v-if="library">
        <v-select v-model="language" :items="languages" :class="$style.languageSection" :style="{'margin-right': $route.name==='Campaign' ? '0px !important' : ''}" :dark="theme==='dark'"/>
    </span>

    <v-dialog
        v-model="confirmLanguageChangeOnV3_PortalActive"
        persistent
        max-width="290"
      >
        <v-card>
            <v-card-title class="justify-center pt-5">
                <SvgIcon :src="getSource" :class=""/>            
            </v-card-title>

            <v-card-text>
                <str index="switch_language > v3 warning" />
            </v-card-text>

            <v-card-actions class="justify-center">
                <v-btn
                  color="blue darken-1"
                  text
                  @click="switchLanguage('cancel')"
                >
                    <str index="button > no" />
                </v-btn>

                <v-btn
                  color="blue darken-1"
                  text
                  @click="switchLanguage('confirm')"
                >
                    <str index="button > yes" />
                </v-btn>
            </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>

<script>
import SvgIcon from '@/components/svg/svg_icon.vue';
import ErrorIcon from '@/assets/images/icons/error.svg';
import languageCodes from "./languageCodes";

export default {
    name: 'language',
    props: {
        theme: {
            type: String,
            required: false,
            default: 'light'
        }
    },
    components: {
        SvgIcon,
        ErrorIcon
    },            
    mounted: function(){
        setTimeout( function(){
            this.init();            
        }.bind(this),1200);
    },
    data: function(){
        return {
            language: null,
            languageCodes: languageCodes,
            confirmLanguageChangeOnV3_PortalActive: false,
            confirmAction: null
        }
    },
    methods: {
        init: function(){
            if( this.userPreferredLanguage === undefined ){ // obtain landing language for unlogged user
                this.customCLog("Language for unlogged user route");
                let browserLanguage = window.navigator.userLanguage || window.navigator.language;
                let browserLangPrimaryCode = browserLanguage.substring( 0, 2 );
                let supportedLangsList = Object.entries(this.languageCodes).filter( elem => elem[1].supported === true ).map(elem => elem[0]);                
                this.language = supportedLangsList.includes(browserLangPrimaryCode) ? browserLangPrimaryCode : this.unlink(this.currentLanguage);
                this.switchLanguage('confirm');
            }    
            else{
                this.language = this.userPreferredLanguage || this.unlink(this.currentLanguage);
            }
            this.customCLog("Init Language :: " + this.language);
        },
        resolveLanguage: function(code){
            return this.languageCodes[code].name ? this.languageCodes[code].name : null
        },
        switchLanguage: function(actn){
            if (actn === 'confirm'){
                this.$store.dispatch('language',this.language);
            }
            else {
                this.language = this.currentLanguage;
            }
            
            this.confirmAction = actn;
            this.confirmLanguageChangeOnV3_PortalActive = false;
        }        
    },
    computed: {
        library: function(){
            return this.$store.getters.library ? this.$store.getters.library : null;
        },
        languages: function(){
            var languages = this.library.languages;
            var list = [];
            for(let code in languages){
                list.push({
                    text: this.windowSize.width > 768 ? this.resolveLanguage(code) : code.toUpperCase(),
                    value: code
                })
            }

            return list;
        },
        currentLanguage: function(){
            return this.$store.getters.language;
        },
        getSource: function(){
            return ErrorIcon;
        },
        userPreferredLanguage: function(){
            return this.$store.getters.user.language;
        },
        windowSize: function() {
            return this.$store.getters.window;
        },
        routeProgram: function(){
            return this.$route.matched.some(elem => elem.name==='program');
        }
    },
    watch: {
        routeProgram: function(after, before){
            if (after===true){
                let programMap =  this.$controller.program.programMap();
                let programId = this.$route.params.program;
                if (programId!==undefined && programMap[programId]){
                    let internationalizationDetails = programMap[programId].internationalization;
                    let defaultLanguage = internationalizationDetails.default;
                    let defaultLanguageName = this.languages.filter(elem => elem.value==defaultLanguage).map(elem => elem.text);
                    if ( !internationalizationDetails.supported.includes(this.language) ){
                        this.$emit("flashMessage", {
                            text: this.labels("message > content_available_language_only") + " " + defaultLanguageName + ". " + this.labels("message > page_displayed_in_language") + " " + defaultLanguageName + ".",
                            top: true,
                            bottom: false,
                            timeout: null
                        });                       
                        let self = this;
                        setTimeout( function(){
                            self.language = defaultLanguage;
                        },200);

                        return this.confirmAction = 'cancel';
                    }
                }
            }
            else { 
            //Check if current langauge identical to users prefference settings and aligned it if not. 
            //This may happens when user access single language supported Program.
            //As result lang switch forcebly switched to program default lang and now it's time to reset it up to user lang of preference.
                if (this.userPreferredLanguage!==this.language){                    
                    this.init();
                    let self = this;
                    setTimeout( function(){
                        self.$emit("flashMessage", {
                            text: self.labels("message > returned_to_preferred_language"),
                            top: true,
                            bottom: false,
                            timeout: null
                        });                         
                    },200);                   
                }
            }
        },
        language: function(after, before){
            if (this.$route.matched.some(elem => elem.name==='program')){ //console.log("Program-Related-Route");
                let programMap =  this.$controller.program.programMap();
                let programId = this.$route.params.program;
                if (programId!==undefined && programMap[programId]){
                    let internationalizationDetails = programMap[programId].internationalization;
                    let defaultLanguage = internationalizationDetails.default;
                    let defaultLanguageName = this.languages.filter(elem => elem.value==defaultLanguage).map(elem => elem.text);
                    if ( !internationalizationDetails.supported.includes(after) ){
                        this.$emit("flashMessage", {
                            text: this.labels('message > content_available_language_only') + ' ' + defaultLanguageName,
                            top: true,
                            bottom: false,
                            timeout: null
                        });                       
                        let self = this;
                        setTimeout( function(){
                            self.language = defaultLanguage;
                        },200);
                        
                        return this.confirmAction = 'cancel';
                    }
                }
            }

            if (this.$store.getters.V3_PortalState == 'opened' 
                    && after !== before 
                    && before !== null 
                    && this.confirmAction !== 'cancel'){
                this.confirmLanguageChangeOnV3_PortalActive = true;
            }
            else {
                this.switchLanguage('confirm');
            }
            
            this.confirmAction = null;
        },
        currentLanguage: function(){
            if(this.currentLanguage != this.language){
                this.language = this.unlink(this.currentLanguage);
            }
        },
        
    }
}
</script>

<style module>
.languageSection {
    width:100px;
    margin: 25px !important;
    border: none;
}

@media screen and (max-width: 768px){
    .languageSection {
        width: 48px;
        font-size: 10px !important;
        line-height:12px;
        text-align: center;
    }
}

@media only screen and (max-width: 455px) {
    .languageSection {
        margin: 10px !important;
    }
}
</style>